import { useMemo } from 'react';

export const DOTS = '...';

const range = (start, end) => {
    const rangeArray = [];
    for (let i = start; i <= end; i += 1) {
        rangeArray.push(i);
    }
    return rangeArray;
};

export const usePagination = ({
    totalCount,
    pageSize,
    siblingCount = 1,
    currentPage,
}) => useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    const totalPagesToShow = 5;

    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
    const totalPageNumbers = siblingCount + totalPagesToShow;

    /*
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPageCount]
    */
    if (totalPageNumbers >= totalPageCount) {
        return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
        currentPage + siblingCount,
        totalPageCount,
    );

    /*
      We do not want to show dots if there is only one position left
      after/before the left/right page count as that would lead to a change if our Pagination
      component size which we do not want
    */
    const indexToConsiderToShowDots = 2;
    const shouldShowLeftDots = leftSiblingIndex > indexToConsiderToShowDots;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - indexToConsiderToShowDots;

    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    // 1st page, last page and current page
    const buttonConst = 3;

    const noOfItemsToShow = 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
        const leftItemCount = buttonConst + noOfItemsToShow * siblingCount;
        const leftRange = range(1, leftItemCount);

        return [...leftRange, DOTS, totalPageCount];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
        const rightItemCount = buttonConst + noOfItemsToShow * siblingCount;
        const rightRange = range(
            totalPageCount - rightItemCount + 1,
            totalPageCount,
        );
        return [firstPageIndex, DOTS, ...rightRange];
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
        const middleRange = range(leftSiblingIndex, rightSiblingIndex);
        return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }

    return range(1, totalPageCount);
}, [totalCount, pageSize, siblingCount, currentPage]);
